export const retrieveImageFromClipboard = pasteEvent => {
    if (!pasteEvent?.clipboardData)
        return null;
    const items = pasteEvent.clipboardData.items;
    if (!(Symbol.iterator in Object(items)))
        return null;
    let blob = null;
    for (const item of items) {
        if (item.type?.startsWith('image')) {
            blob = item.getAsFile();
            break;
        }
    }
    return blob;
};
export const getImageURLFromBlob = imageBlob => {
    const URLObj = window.URL || window.webkitURL;
    return !imageBlob ? '' : URLObj.createObjectURL(imageBlob);
};
//# sourceMappingURL=index.js.map